export const accordion = (function ($) {

    let $accordion = $('.js-toggle-accordion');

    function toggleAccordion ($this) {
        if ($this.parent().hasClass('is-open')) {
            $this.parent().removeClass('is-open');
            $this.next(".accordion__inner").css("max-height", "0px");
        } else {
            // first close all other accordions
            $accordion.parent().removeClass('is-open');
            $accordion.next(".accordion__inner").css("max-height", "0px");
            // then open the clicked one
            $this.parent().addClass('is-open');
            $this.next(".accordion__inner").css("max-height", $this.next(".accordion__inner").find(".accordion__content").innerHeight() + "px");
        }
    }

    function init() {
        $accordion.click(function (e) {
            e.preventDefault();
            let $this = $(this);

            toggleAccordion($this);
        });
    }

    return {
        init: init
    }

})(jQuery);